import {
    ADVERTISEMENT_GET,
    ADVERTISEMENT_CLEAR,
    ADVERTISEMENT_LOADING_STATUS
} from './types'
import LocalStorageService from '@/services/local-storage.service'
import store from '@/store'
import axios from 'axios'

const getBanner = async (ctx, payload) => {
    try {
        ctx.commit(ADVERTISEMENT_LOADING_STATUS, true)
        const credentials = JSON.parse(LocalStorageService.get('settings')).advertisement
        if (!credentials) {
            await ctx.dispatch('settings/getAdvertisementUrl', null, {root: true})
        }
        const profile = store.getters['auth/profile']
        if (profile) {
            const credentials = JSON.parse(LocalStorageService.get('settings')).advertisement
            const { data } = await axios.get(`${credentials.value.url}/banners`, {
                headers: {
                    'access-token': credentials.value.auth_key
                },
                params: {
                    version: 2,
                    membership_type: profile.is_member,
                    chapter_id: profile.chapters.map(chapter => chapter.chapter_id),
                    ...payload
                }
            })
            ctx.commit(ADVERTISEMENT_GET, data[payload.places[0]][0])
        }
    } catch (e) {
        console.log(e)
        throw e
    } finally {
        ctx.commit(ADVERTISEMENT_LOADING_STATUS, false)
    }
}

const clearBanner = async (ctx) => {
    try {
        ctx.commit(ADVERTISEMENT_CLEAR)
    } catch (e) {
        console.log(e)
        throw e
    }
}

const recordBannerView = async (ctx, url) => {
    try {
        axios.get(url)
    } catch (e) {
        console.log(e)
        throw e
    }
}

export default {
    getBanner,
    clearBanner,
    recordBannerView
}